import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import Alert from '@parkdna/ui/Alert';
import TimezoneAutocomplete from '@parkdna/ui/TimezoneAutocomplete';
import { useState } from 'react';

import {
  useGetCurrentUser,
  useUpdateCurrentUser,
} from '@/hooks/queries/organization';

export function TimezoneSetupDialog() {
  const { user, isLoading } = useGetCurrentUser();
  const { mutateAsync, isPending } = useUpdateCurrentUser();
  const [selectedTimezone, setSelectedTimezone] = useState<string | null>(null);

  const userTimezone = user?.user_metadata?.timezone as string | undefined;
  const isOpen = !isLoading && !userTimezone;

  const handleSave = async () => {
    if (!selectedTimezone) return;

    await mutateAsync({
      data: {
        timezone: selectedTimezone,
      },
    });
  };

  return (
    <Dialog
      open={isOpen}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          sx: { backdropFilter: 'blur(4px)' },
        },
      }}
    >
      <DialogTitle>Set Your Timezone</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2.5} pt={1}>
          <Alert
            show
            severity="error"
            title="Timezone Required"
            description="Setting your timezone is required to continue. All dates and times in the portal will be displayed in your selected timezone. Select 'Auto' if you want us to automatically infer your timezone based on your browser."
            sx={{ mt: 0, mb: 0 }}
          />
          <TimezoneAutocomplete
            value={selectedTimezone}
            onChange={setSelectedTimezone}
            label="Display Timezone"
            required
            showAutoOption
            helperText="Select your preferred timezone for displaying dates and times."
          />
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSave}
            loading={isPending}
            disabled={!selectedTimezone}
            size="large"
            sx={{ alignSelf: 'end' }}
          >
            Save and continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
